import React from 'react'
import PropTypes from 'prop-types'

import {ReactComponent as IconAttachment} from '../assets/images/attach_icn.svg'

const ButtonFile = ({ handlerClick }) => {
  return (
    <div className="button-file">
      <button className='btn'>
        <IconAttachment />
      </button>
       <input
        type='file'
        multiple
        onClick={event => {
          event.target.value = null
        }}
        onChange={handlerClick}
        />
    </div>
  )
}

ButtonFile.propTypes = {
  handlerClick: PropTypes.func
}

export default ButtonFile